// extracted by mini-css-extract-plugin
module.exports = {"profileCard":"Card_profileCard__2v-JP","name":"Card_name__3-45g","location":"Card_location__1EY0Q","onlyFansConnected":"Card_onlyFansConnected__2hiMQ"};